import { PlanSettingsForm } from '@/billing/PlanSettingsForm'

export function BillingSettings() {
  return <PlanSettingsForm />
}
